module.exports = __webpack_public_path__ + "img/1 (126).7f1331a7.png";